import { combineReducers } from 'redux';
import notices from './notices.reducer';

const reducer = combineReducers({
	notices
});

export default reducer;
